import {Breadcrumbs, CircularProgress, Grid} from '@mui/material';
import React, {useEffect, useState} from 'react';
import PageTitle from '../../../common/PageTitle';
import CardOption from '../../../common/CardOption';
import HomeIcon from '@mui/icons-material/Home';
import LinkNavegacao from '../../../common/Link';
import { Rule } from '@mui/icons-material';
import {verifyUserAbilities} from "../../../config/functions";

function Guidelines() {
    const [abilities, setAbilities] = useState({});
    const [loading, setLoading] = useState(true);

    const permissoesNecessarias = [
        { rota: "grupos", title: "Regras para Grupos de Trabalho e Permissões", description: "Cadastre grupos de trabalho e seus EPIs permitidos, além de definir prazos para solicitações. Controle o acesso de forma eficiente, adaptando-se às necessidades de cada equipe.", url: "ghes" },
        { rota: "justificativaRequisicao", title: "Justificativas para pedidos fora de regra", description: "Crie justificativas para solicitações de EPIs fora das regras predefinidas. Permita flexibilidade quando necessário, garantindo segurança e atendendo às circunstâncias específicas dos colaboradores.", url: "justificativa_requisicao"},
        { rota: "justificativaDevolucao", title: "Justificativas de Devolução", description: "Permita flexibilidade quando necessário, garantindo segurança e atendendo às circunstâncias específicas dos colaboradores.", url: "justificativa_devolucao"}
    ];

    useEffect(() => {
        const carregarPermissoes = async () => {
            const resultados = {};

            for (const item of permissoesNecessarias) {
                resultados[item.rota] = await verifyUserAbilities({ rota: item.rota });
            }

            setAbilities(resultados);
            setLoading(false);
        };

        carregarPermissoes();
    }, []);


    if (loading) {
        return (
            <Grid container justifyContent="center" alignItems="center" style={{ height: "100vh" }}>
                <CircularProgress />
            </Grid>
        );
    }

    return (<>
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="stretch"
            spacing={3}

        >
            <Grid item xs={12}>
                <Breadcrumbs>
                    <LinkNavegacao to='/'><HomeIcon fontSize='small' /></LinkNavegacao >
                    <LinkNavegacao to='/epis'>Gestão de EPI's</LinkNavegacao >
                    <LinkNavegacao to='/epis/diretrizes'>Diretrizes</LinkNavegacao >
                </Breadcrumbs>
                <PageTitle icon={<Rule fontSize='large' />} title='Diretrizes' />
            </Grid>

            {permissoesNecessarias.map((item) => {
                const temPermissao = abilities[item.rota]?.data.success;
                return (
                    <Grid
                        key={item.rota}
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        lg={4}
                        xl={3}
                        sx={{
                            opacity: temPermissao ? 1 : 0.5,
                            pointerEvents: temPermissao ? 'auto' : 'none',
                        }}
                    >
                        <CardOption
                            title={item.title}
                            description={item.description}
                            url={item.url}
                            hasPermisson={temPermissao}
                            sx={{
                                backgroundColor: temPermissao ? 'transparent' : 'gray',
                                color: temPermissao ? 'black' : 'gray',
                            }}
                        />
                    </Grid>
                );
            })}
        </Grid>
    </>);
}

export default Guidelines;